import cn from 'classnames';
import styles from './Loading.module.scss';

interface LoadingProps {
  fullScreen?: boolean;
}

export const Loading = ({ fullScreen = false }: LoadingProps) => {
  return (
    <div className={cn(styles.root, fullScreen && styles['full-screen'])}>
      <div className={styles.spinner} id="spinner-loading" />
      <span>Loading</span>
    </div>
  );
};
